import type { AdapterMeta } from "@repo/adapter-core";

export const BARRY_PLANT_META: AdapterMeta = {
  slug: "barry-plant",
  name: "Barry Plant",
  baseUrl: "https://www.barryplant.com.au",
  description: "Broad suburban VIC coverage from one of Melbourne's largest real estate networks.",
  supportedStates: ["VIC"],
  urlPattern: /barryplant\.com\.au\/sold-properties\/[a-z0-9-]+-\d+/i,
  sourceType: "agency",
};
